import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";
import { Wifi, Flame, ChefHat, Mountain, MapPin, Coffee } from "lucide-react";

const iconMap = { wifi: Wifi, flame: Flame, campfire: Flame, "chef-hat": ChefHat, mountain: Mountain, car: MapPin, thermometer: Coffee, bath: Coffee };

export default function AmenitiesPage() {
  const [data, setData] = useState(null);
  useEffect(() => { http.get("/public/property").then((r) => setData(r.data)); }, []);
  if (!data) return null;
  return (
    <div>
      <PublicHeader />
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-16">
        <div className="eyebrow mb-3">Amenities</div>
        <h1 className="h1-hero text-5xl md:text-6xl mb-10">Included in your stay</h1>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
          {data.amenities.map((a, i) => {
            const Icon = iconMap[a.icon] || Coffee;
            return (
              <div key={a.id} className="card text-center" data-testid={`amenities-page-${i}`}>
                <div className="inline-flex w-14 h-14 rounded-full items-center justify-center mb-4" style={{ background: "var(--terracotta-subtle)", color: "var(--terracotta)" }}><Icon size={26} /></div>
                <div className="font-serif text-xl">{a.name}</div>
              </div>
            );
          })}
        </div>
      </div>
      <PublicFooter />
    </div>
  );
}
